import { cn } from "@/lib/utils";
import React from "react";
export interface HeaderTitleProps {
  title: string;
  description: string;
  titleAndDescription?: React.ReactNode;
  className?: string;
}

export function HeaderTitleComponent({
  title,
  description,
  titleAndDescription,
  className,
}: HeaderTitleProps) {
  return (
    <section
      className={cn("p-6", className)}
      data-testid="table-title"
      aria-labelledby="table-title-label"
      role="region"
    >
      {titleAndDescription ? (
        titleAndDescription
      ) : (
        <>
          <h2
            data-testid="table-title-h1"
            id="table-title-label"
            className="text-[16px] leading-tight font-semibold"
            tabIndex={-1}
          >
            {title}
          </h2>
          <p
            className="text-sm text-primary-light"
            id="table-description"
            data-testid="table-description"
            aria-label={description}
          >
            {description}
          </p>
        </>
      )}
    </section>
  );
}
